import axios from '@/service/request';
import type { R } from './types';
import type { AxiosRequestConfig } from 'axios';

interface ProtocolDetailResponse {
  id: string;
  title: string;
  content: string;
  createTime: string;
  updateTime: string;
  langExt: string;
}

/**
 * 协议详情
 */
export const apiProtocolDetail = (data: { protocolId: string }, config?: AxiosRequestConfig): Promise<R<ProtocolDetailResponse>> => {
  return axios.post('/buyer/protocolDetail', data, config);
};

